import { Button, Card, Checkbox, Col, Divider, Flex, Row, Space } from "antd";
import { Footer } from "antd/es/layout/layout";
import { Info } from "components/elements";
import { Input, Select } from "components/form";
import { Form, Formik } from "formik";
import { useTranslation } from "react-i18next";
import { ReactComponent as EyeHideIcon } from "../../../assets/icon/eyeClose.svg";
import { ReactComponent as EyeIcon } from "../../../assets/icon/eyeIcon.svg";
import { ReactComponent as EditIcon } from "../../../assets/images/edit.svg";
import schema from "../schemas/employeeInfoContactProfileSchema";
import styles from "../styles/EmployeeForm.module.css";

function EmployeeContactInfoProfile({
    isEditing = false,
    contactInfo = {},
    initialValues = {},
    relationshipOptions = [],
    provinceOptionsTh = [],
    provinceOptionsEn = [],
    districtOptionsTh = [],
    districtOptionsEn = [],
    subDistrictOptionsTh = [],
    subDistrictOptionsEn = [],
    handleProviceChange = () => { },
    handleDistrictChange = () => { },
    registeredProvinceOptionsTh = [],
    registeredProvinceOptionsEn = [],
    registeredDistrictOptionsTh = [],
    registeredDistrictOptionsEn = [],
    registeredSubDistrictOptionsTh = [],
    registeredSubDistrictOptionsEn = [],
    handleRegisteredProviceChange = () => { },
    handleRegisteredDistrictChange = () => { },
    onEdit = () => { },
    onSubmitEditProfile = () => { },
    onCancel = () => { },
    isVisible = false,
    setIsVisible = () => { },
    pageForm = "PROFILE",
    handleToggleVisibility = () => { },
    permissions
}) {
    const { t } = useTranslation();
    const checkDisableVisible = () => {
        if (pageForm === "PROFILE") {
            return permissions?.VISIBLE ? false : true
        }
    }
    const checkDisableUpdate = () => {
        if (pageForm === "PROFILE") {
            return permissions?.UPDATE ? false : true
        }
    }
    if (isEditing) {
        return (
            <Card style={{ border: "1px solid #EAECF0" }}>
                <Formik enableReinitialize initialValues={{ ...initialValues }} validationSchema={schema} onSubmit={onSubmitEditProfile}>
                    {({ values, setFieldValue, setTouched }) => {
                        const onProviceChange = (val) => {
                            handleProviceChange(val);
                            setFieldValue("districtId", null);
                            setFieldValue("subDistrictId", null);
                            setFieldValue("zipCode", null);
                            setTouched(
                                {
                                    districtId: false,
                                    subDistrictId: false,
                                    zipCode: false,
                                },
                                false
                            );
                        };

                        const onDistrictChange = (val) => {
                            handleDistrictChange(val);
                            setFieldValue("subDistrictId", null);
                            setFieldValue("zipCode", null);
                            setTouched(
                                {
                                    subDistrictId: false,
                                    zipCode: false,
                                },
                                false
                            );
                        };

                        const onSubDistrictChange = (val) => {
                            setFieldValue("zipCode", val.zipCode || null);
                            setTouched({ zipCode: false }, false);
                        };

                        const onRegisteredProviceChange = (val) => {
                            handleRegisteredProviceChange(val);
                            setFieldValue("registerDistrictId", null);
                            setFieldValue("registerSubDistrictId", null);
                            setFieldValue("registerZipCode", null);
                            setTouched(
                                {
                                    registerDistrictId: false,
                                    registerSubDistrictId: false,
                                    registerZipCode: false,
                                },
                                false
                            );
                        };

                        const onRegisteredDistrictChange = (val) => {
                            handleRegisteredDistrictChange(val);
                            setFieldValue("registerSubDistrictId", null);
                            setFieldValue("registerZipCode", null);
                            setTouched(
                                {
                                    registerSubDistrictId: false,
                                    registerZipCode: false,
                                },
                                false
                            );
                        };

                        const onRegisteredSubDistrictChange = (val) => {
                            setFieldValue("registerZipCode", val.zipCode || null);
                            setTouched({ registerZipCode: false }, false);
                        };

                        const handleSameRegisterAddressChange = () => {
                            values.sameRegisterAddress === "Y" ? setFieldValue("sameRegisterAddress", "N") : setFieldValue("sameRegisterAddress", "Y");
                        };

                        return (
                            <Form>
                                {/* <Card> */}
                                <Space style={{ width: "100%" }} size={24} direction="vertical">
                                    {/* <Space size={12} direction="vertical"> */}
                                    <span style={{ fontSize: "16px", fontWeight: "bold" }}>{t("contact-information-0")}</span>
                                    <Row gutter={[24, 0]} style={{ rowGap: "16px" }}>
                                        <Col span={8}>
                                            <Input
                                                name="email"
                                                label={t("company-e-mail-username-0")}
                                                placeholder={t("company-e-mail-username-0")}
                                                size="large"
                                                disabled
                                            />
                                        </Col>
                                        <Col span={8} >
                                            <Input
                                                name="telephoneNumber"
                                                label={t("telephone-no")}
                                                placeholder={t("telephone-no")}
                                                size="large"
                                                onChange={(e) => {
                                                    setFieldValue("telephoneNumber", e.replace(/\D/g, ''))
                                                }}
                                            />
                                        </Col>
                                        <Col span={8} >
                                            <Input
                                                name="personalEmail"
                                                label={t("personal-email-address")}
                                                placeholder={t("personal-email-address")}
                                                size="large"
                                            />
                                        </Col>
                                        <Col span={8} >
                                            <Input
                                                name="mobileNumber"
                                                label={t("mobile-no-0")}
                                                placeholder={t("mobile-no-0")}
                                                onChange={(e) => {
                                                    setFieldValue("mobileNumber", e.replace(/\D/g, ''))
                                                }}
                                                size="large"
                                            />
                                        </Col>
                                        <Col span={8} >
                                            <Input
                                                name="lineId"
                                                label={t("line-id")}
                                                placeholder={t("line-id")}
                                                size="large"
                                            />
                                        </Col>
                                    </Row>
                                    {/* </Space> */}
                                    <Divider className={styles.customDivider} />
                                    <div>
                                        <Flex vertical style={{ rowGap: "12px" }}>
                                            <span style={{ fontSize: "16px", fontWeight: "bold" }}>{t("register-address-information-0")}</span>
                                            <Row gutter={24} >
                                                <Col span={8} >
                                                    <Input
                                                        required
                                                        name="registerAddress"
                                                        label={t("company_profile.label.address_th")}
                                                        placeholder={t('company_profile.label.address_detail_th_placeholder')}
                                                        size="large"
                                                    />
                                                </Col>
                                                <Col span={8} >
                                                    <Select
                                                        required
                                                        name="registerProvinceId"
                                                        label={t("address.province")}
                                                        placeholder={t('company_profile.label.please_select')}
                                                        size="large"
                                                        options={registeredProvinceOptionsTh}
                                                        onChange={(_, item) => {
                                                            onRegisteredProviceChange(item?.provinceCode)
                                                            if (values.sameRegisterAddress === "Y") {
                                                                setFieldValue("provinceId", item.provinceId)
                                                            }
                                                        }}
                                                    />
                                                </Col>
                                                <Col span={8} >
                                                    <Select
                                                        required
                                                        name="registerDistrictId"
                                                        label={t("address.district")}
                                                        placeholder={t('company_profile.label.please_select')}
                                                        size="large"
                                                        options={registeredDistrictOptionsTh}
                                                        onChange={(_, item) => {
                                                            onRegisteredDistrictChange(item?.districtCodeId)
                                                            if (values.sameRegisterAddress === "Y") {
                                                                setFieldValue("districtId", item.districtId)

                                                            }
                                                        }}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row gutter={24}>
                                                <Col span={8} >
                                                    <Select
                                                        required
                                                        name="registerSubDistrictId"
                                                        label={t("address.subdistrict")}
                                                        placeholder={t('company_profile.label.please_select')}
                                                        size="large"
                                                        options={registeredSubDistrictOptionsTh}
                                                        onChange={(_, item) => {
                                                            onRegisteredSubDistrictChange(item);
                                                            if (values.sameRegisterAddress === "Y") {
                                                                setFieldValue("subDistrictId", item.subDistrictId)
                                                            }
                                                        }}
                                                    />
                                                </Col>
                                                <Col span={8} >
                                                    <Input
                                                        required
                                                        name="registerZipCode"
                                                        label={t("address.postal_code")}
                                                        placeholder={t('company_profile.label.please_select')}
                                                        size="large"
                                                        maxLength={5}
                                                        disabled
                                                    />
                                                </Col>
                                            </Row>
                                            {/* <p
                      style={{

                        borderStyle: "dashed",
                        borderColor: "rgb(112, 200, 212)",
                        borderWidth: "thin",
                        paddingBottom: "5px",
                        marginTop: '10px '
                      }}
                    ></p> */}
                                            <Row gutter={24}>
                                                <Col span={8} >
                                                    <Input
                                                        required
                                                        name="registerAddressEn"
                                                        label={t("company_profile.label.address_en")}
                                                        placeholder={t('company_profile.label.address_detail_en_placeholder')}
                                                        size="large"
                                                    />
                                                </Col>
                                                <Col span={8} >
                                                    <Select
                                                        required
                                                        name="registerProvinceId"
                                                        label={t("address.province")}
                                                        placeholder={t('company_profile.label.please_select')}
                                                        size="large"
                                                        options={registeredProvinceOptionsEn}
                                                        onChange={(_, item) => {
                                                            onRegisteredProviceChange(item?.provinceCode)
                                                            if (values.sameRegisterAddress === "Y") {
                                                                setFieldValue("provinceId", item.provinceId)
                                                            }
                                                        }}
                                                    />
                                                </Col>
                                                <Col span={8} >
                                                    <Select
                                                        required
                                                        name="registerDistrictId"
                                                        label={t("address.district")}
                                                        placeholder={t('company_profile.label.please_select')}
                                                        size="large"
                                                        options={registeredDistrictOptionsEn}
                                                        onChange={(_, item) => {
                                                            onRegisteredDistrictChange(item?.districtCodeId)
                                                            if (values.sameRegisterAddress === "Y") {
                                                                setFieldValue("districtId", item.districtId)
                                                            }
                                                        }}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row gutter={24}>
                                                <Col span={8}>
                                                    <Select
                                                        required
                                                        name="registerSubDistrictId"
                                                        label={t("address.subdistrict")}
                                                        placeholder={t('company_profile.label.please_select')}
                                                        size="large"
                                                        options={registeredSubDistrictOptionsEn}
                                                        onChange={(_, item) => {
                                                            onRegisteredSubDistrictChange(item);
                                                            if (values.sameRegisterAddress === "Y") {
                                                                setFieldValue("subDistrictId", item.subDistrictId)
                                                            }
                                                        }}
                                                    />
                                                </Col>
                                                <Col span={8}>
                                                    <Input
                                                        required
                                                        name="registerZipCode"
                                                        label={t("address.postal_code")}
                                                        placeholder={t('company_profile.label.please_select')}
                                                        size="large"
                                                        maxLength={5}
                                                        onChange={(_, item) => {
                                                            if (values.sameRegisterAddress === "Y") {
                                                                setFieldValue("zipCode", item.zipCode)
                                                            }
                                                        }}
                                                        disabled
                                                    />
                                                </Col>
                                            </Row>
                                        </Flex>

                                    </div>

                                    <Divider className={styles.customDivider} />

                                    <div>
                                        <span style={{ fontSize: "16px", fontWeight: "bold" }}>{t("address-information-0")}</span>
                                        <Flex vertical style={{ rowGap: "12px" }}>
                                            <Row gutter={[24, 0]}>
                                                <Col span={12}>
                                                    <Checkbox
                                                        checked={values.sameRegisterAddress === "Y"}
                                                        onChange={handleSameRegisterAddressChange}
                                                    >
                                                        {t("same-register-address")}
                                                    </Checkbox>
                                                </Col>
                                            </Row>
                                            {(values.sameRegisterAddress === "N" || values.sameRegisterAddress === null) && <>
                                                <Row gutter={[24, 0]}>
                                                    <Col span={8}>
                                                        <Input
                                                            required={true}
                                                            name="address"
                                                            label={t("company_profile.label.address_th")}
                                                            placeholder={t('company_profile.label.address_detail_th_placeholder')}
                                                            size="large"
                                                        />
                                                    </Col>
                                                    <Col span={8}>
                                                        <Select
                                                            required={true}
                                                            name="provinceId"
                                                            label={t("address.province")}
                                                            placeholder={t('company_profile.label.please_select')}
                                                            size="large"
                                                            options={provinceOptionsTh}
                                                            onChange={(_, item) => {
                                                                onProviceChange(item?.provinceCode)
                                                            }}
                                                        />
                                                    </Col>
                                                    <Col span={8}>
                                                        <Select
                                                            required={true}
                                                            name="districtId"
                                                            label={t("address.district")}
                                                            placeholder={t('company_profile.label.please_select')}
                                                            size="large"
                                                            options={districtOptionsTh}
                                                            onChange={(_, item) => {
                                                                onDistrictChange(item.districtCodeId)
                                                            }}
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row gutter={[24, 0]}>
                                                    <Col span={8} >
                                                        <Select
                                                            required={true}
                                                            name="subDistrictId"
                                                            label={t("address.subdistrict")}
                                                            placeholder={t('company_profile.label.please_select')}
                                                            size="large"
                                                            options={subDistrictOptionsTh}
                                                            onChange={(_, item) => {
                                                                onSubDistrictChange(item)
                                                                console.log("item", item);
                                                            }}
                                                        />
                                                    </Col>
                                                    <Col span={8} >
                                                        <Input
                                                            required={true}
                                                            name="zipCode"
                                                            label={t("address.postal_code")}
                                                            placeholder={t('company_profile.label.please_select')}
                                                            size="large"
                                                            maxLength={5}
                                                            disabled
                                                        />
                                                    </Col>
                                                </Row>

                                                <Row gutter={[24, 0]}>
                                                    <Col span={8}>
                                                        <Input
                                                            required={true}
                                                            name="addressEn"
                                                            label={t("company_profile.label.address_en")}
                                                            placeholder={t('company_profile.label.address_detail_en_placeholder')}
                                                            size="large"
                                                        />
                                                    </Col>
                                                    <Col span={8}>
                                                        <Select
                                                            required={true}
                                                            name="provinceId"
                                                            label={t("address.province")}
                                                            placeholder={t('company_profile.label.please_select')}
                                                            size="large"
                                                            options={provinceOptionsEn}
                                                            onChange={(_, item) => {
                                                                onProviceChange(item?.provinceCode)
                                                            }}
                                                        />
                                                    </Col>
                                                    <Col span={8}>
                                                        <Select
                                                            required={true}
                                                            name="districtId"
                                                            label={t("address.district")}
                                                            placeholder={t('company_profile.label.please_select')}
                                                            size="large"
                                                            options={districtOptionsEn}
                                                            onChange={(_, item) => {
                                                                onDistrictChange(item.districtCodeId)
                                                            }}
                                                        />
                                                    </Col>
                                                </Row>

                                                <Row gutter={[24, 0]}>
                                                    <Col span={8}>
                                                        <Select
                                                            required={true}
                                                            name="subDistrictId"
                                                            label={t("address.subdistrict")}
                                                            placeholder={t('company_profile.label.please_select')}
                                                            size="large"
                                                            options={subDistrictOptionsEn}
                                                            onChange={(_, item) => {
                                                                onSubDistrictChange(item);
                                                                console.log("item", item);
                                                            }}
                                                        />
                                                    </Col>
                                                    <Col span={8} >
                                                        <Input
                                                            required={true}
                                                            name="zipCode"
                                                            label={t("address.postal_code")}
                                                            placeholder={t('company_profile.label.please_select')}
                                                            size="large"
                                                            maxLength={5}
                                                            disabled
                                                        />
                                                    </Col>
                                                </Row>
                                            </>
                                            }
                                        </Flex>
                                    </div>

                                    <Divider className={styles.customDivider} />
                                    <Space size={12} direction="vertical" style={{ width: "100%" }}>
                                        <span style={{ fontSize: "16px", fontWeight: "bold" }}>{t("emergency-contacts-0")}</span>
                                        {/* <Flex vertical style={{ rowGap: "12px" }}> */}
                                        <Row gutter={[24, 0]} style={{ rowGap: "16px" }}>
                                            <Col span={8} >
                                                <Input
                                                    name="emergencyName"
                                                    label={t("name")}
                                                    placeholder={t("name")}
                                                    size="large"
                                                />
                                            </Col>
                                            <Col span={8}>
                                                <Input
                                                    name="emergencysurName"
                                                    label={t("surname")}
                                                    placeholder={t("surname")}
                                                    size="large"
                                                />
                                            </Col>
                                            <Col span={8}>
                                                <Select
                                                    name="relationshipId"
                                                    label={t("relationship")}
                                                    placeholder={t('company_profile.label.please_select')}
                                                    size="large"
                                                    options={relationshipOptions}
                                                />
                                            </Col>
                                            <Col span={8} >
                                                <Input
                                                    name="emergencyMobileNumber"
                                                    label={t("mobile-no")}
                                                    placeholder={t("mobile-no")}
                                                    size="large"
                                                />
                                            </Col>
                                        </Row>
                                    </Space>
                                    {/* </Flex> */}
                                </Space>
                                {/* </Card> */}

                                <Footer style={{
                                    zIndex: 999,
                                    bottom: 2,
                                    position: 'sticky',
                                    backgroundColor: 'white',
                                    height: "max-content",
                                    placeContent: "center"
                                }}>
                                    <Row justify="end" style={{ gap: "10px" }}>
                                        <Button type="default" onClick={() => {
                                            onCancel()
                                        }} style={{ width: "max-content", height: "40px", borderRadius: "8px", padding: "8px 16px" }}
                                        >
                                            {t("common.cancel").toUpperCase()}
                                        </Button>
                                        <Button type="primary" htmlType="submit" style={{ width: "max-content", height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "8px 16px", color: "white" }}>
                                            {t("common.submit").toUpperCase()}
                                        </Button>
                                    </Row>
                                </Footer>
                            </Form>
                        );
                    }}
                </Formik>
            </Card>
        )
    }

    // console.log("ma paaaaaao", contactInfo);


    return (
        <Card style={{ border: "solid 1px #EAECF0" }}>
            <Space style={{ width: "100%" }} size={16} direction="vertical" >
                {/* {roles.includes("UPDATE_EMPLOYEE|EMPLOYEE_INFO|CONTACT_INFO") && */}
                <Row style={{ gap: "10px" }} justify="end" >
                    <Button style={{ width: "max-content", height: "40px", borderRadius: "8px", padding: "10px 16px" }}
                        icon={isVisible ? <EyeHideIcon /> : <EyeIcon />}
                        onClick={handleToggleVisibility}
                        disabled={checkDisableVisible()}
                    />
                    <Button onClick={onEdit} type="primary"
                        style={{ width: "max-content", height: "max-content", borderRadius: "8px", backgroundColor: checkDisableUpdate() ? "" : "var(--button-color)", padding: "8px 16px" }}
                        disabled={checkDisableUpdate()}
                    >
                        <Flex align="center" justify="center" gap={8}>
                            <EditIcon />
                            {t("common.edit").toUpperCase()}
                        </Flex>
                    </Button>
                </Row>
                {/* } */}

                <Flex vertical style={{ rowGap: "16px" }}>
                    <span style={{ fontSize: "16px" }}>{t('contact-information')}</span>

                    <Row gutter={[0, 16]}>
                        <Col span={8}>
                            <Info
                                label={t('company-e-mail-username')}
                                value={contactInfo?.email || "-"}
                            />
                        </Col>
                        <Col span={8}>
                            <Info
                                label={t('employee.telephone-no')}
                                value={contactInfo?.telephoneNumber || "-"}
                            />
                        </Col>
                        <Col span={8}>
                            <Info
                                label={t('employee.personal-email-address')}
                                value={contactInfo?.personalEmail || "-"}
                            />
                        </Col>
                        <Col span={8}>
                            <Info label={t('employee.mobile-no')} value={contactInfo?.mobileNumber || "-"} />
                        </Col>
                        <Col span={8}>
                            <Info label={t('employee.line-id')} value={contactInfo?.lineId || "-"} />
                        </Col>
                    </Row>
                </Flex>

                <Divider className={styles.customDivider} />

                <Flex vertical style={{ rowGap: "16px" }}>
                    <span style={{ fontSize: "16px" }}>{t('register-address-information')}</span>
                    <Row gutter={[0, 16]}>
                        <Col span={24}>
                            <Info
                                label={t('employee.address-th')}
                                value={contactInfo?.registerAddress ? contactInfo?.fullRegisterAddress : "-"}
                            />
                        </Col>
                        <Col span={24}>
                            <Info
                                label={t('employee.address-en')}
                                value={contactInfo?.registerAddressEn ? contactInfo?.fullRegisterAddressEn : "-"}
                            />
                        </Col>
                    </Row>
                </Flex>

                <Divider className={styles.customDivider} />

                <Flex vertical style={{ rowGap: "16px" }}>
                    <span style={{ fontSize: "16px" }}>{t('address-information')}</span>
                    <Row gutter={[0, 16]}>
                        <Col span={24}>
                            <Info label={t('employee.address-th')} value={contactInfo?.address ? contactInfo?.fullAddress : "-"} />
                        </Col>
                        <Col span={24}>
                            <Info label={t('employee.address-en')} value={contactInfo?.addressEn ? contactInfo?.fullAddressEn : "-"} />
                        </Col>
                    </Row>
                </Flex>

                <Divider className={styles.customDivider} />

                <Flex vertical style={{ rowGap: "16px" }}>
                    <span style={{ fontSize: "16px" }}>{t('emergency-contacts')}</span>
                    <Row gutter={[0, 16]}>
                        <Col span={12}>
                            <Info label={t('employee.name')} value={contactInfo?.emergencyName || "-"} />
                        </Col>
                        <Col span={12}>
                            <Info label={t('employee.surname')} value={contactInfo?.emergencysurName || "-"} />
                        </Col>
                        <Col span={12}>
                            <Info
                                label={t('employee.relationship')}
                                value={contactInfo?.relationship?.name || "-"}
                            />
                        </Col>
                        <Col span={12}>
                            <Info
                                label={t('employee.mobile-no')}
                                value={contactInfo?.emergencyMobileNumber || "-"}
                            />
                        </Col>
                    </Row>
                </Flex>
            </Space>
        </Card>
    )

}

export default EmployeeContactInfoProfile;